import { Component, OnInit } from '@angular/core';
import { AcordoService, DevedorService } from '../../services';
import { ActivatedRoute, Router, Params } from '@angular/router'; 
import { Subscription } from 'rxjs';
import { DetalheBaseController } from '../../helpers';
import { EmailService } from 'app/services/email.service';
import { LogSistemaService } from '../../services/logSistema.service';

@Component({
    templateUrl: 'home.component.html'
})

export class HomeComponent extends DetalheBaseController implements OnInit {
    
    subDevedor: Subscription;    
    _currentUser: any;   
    contrato: number;    
                       
    constructor(private router: Router, route: ActivatedRoute, private _acordoService: AcordoService, private _devedor: DevedorService,
        private _emailService: EmailService, private _logSistema: LogSistemaService) {            
        super(route, _acordoService);        
        this.Inicializar();     

        //Determina se uma rota deve ser reutilizada
        this.router.routeReuseStrategy.shouldReuseRoute = function(){
            return false;
         }
         this.router.events.subscribe((evt) => {          
               this.router.navigated = false;  
        });
    }       

    Inicializar() {
        this._currentUser = JSON.parse(localStorage.getItem('currentUserCobranca'));
        if (this._currentUser != null && this._currentUser.validacaoDados != null && this._currentUser.validacaoDados == false)
            this.verificaCadastroCompleto();                
    }

    ngOnInit(){
        this._route.params
        .subscribe((params: Params) => {
            this.contrato = params['id'];              
        });        
    }

    ngAfterViewInit() {
        var msg = localStorage.getItem('msgSucesso');
        if (msg) {
            this._notificationsService.Sucesso(this.translate.instant("controllerBase.sucesso"), msg);
            localStorage.removeItem('msgSucesso');
        }    
    }   

    verificaCadastroCompleto() {      
        this._currentUser.validacaoDados = true;
        localStorage.setItem('currentUserCobranca', JSON.stringify(this._currentUser));
        this._loading.fecharTodos();
    }   

    ngOnDestroy() {        
         if (this.subDevedor) this.subDevedor.unsubscribe();
        super.ngOnDestroy();
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/home/home.component.ts